export default __webpack_public_path__ + "static/media/eiman-logo.399f40b4.png";